module.exports = __webpack_public_path__ + "static/media/open.4e1d8eaf.svg";